import type { ActiveTotals } from '@/api/listTotals';
import type { LabeledStat } from '@/components/common/StatCardGrid';

export function getActiveStatCard(totals: ActiveTotals | undefined): LabeledStat {
  return {
    key: 'active',
    label: 'Active',
    value: totals?.active,
  };
}

export function getInactiveStatCard(totals: ActiveTotals | undefined): LabeledStat {
  return {
    key: 'inactive',
    label: 'Inactive',
    value: totals?.inactive,
  };
}
